import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import AudioCompressCompleteRender from './children/AudioExtractorCompleteRender';
import '@/assets/audioExtractor.less';
import Utils from '../../../../../utils';
import sendGaEvent from '@/ga';
class AudioExtractorCompleteFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  openDownLoadDialog = () => {
    this.props.downloadPercent(0);
    this.props.advertiseConfig({
      isShowHeader: true,
      headerObj: 'download',
      titleIndex: 5,
      imgIndex: 2,
      source: 'download',
    });
    this.props.openAdvertiseDialog(true);
    sendGaEvent({
      category: 'vc_referral',
      action: 'AudioExtractor_DownloadingShow',
    });
  };
  downloadFile = async (obj, format, nameKey, downloadModal) => {
    let url =
      obj.downloadurl || obj.videofileurl || obj.audiofileurl || obj.fileurl;
    let newName = nameKey ? obj[nameKey].split('.')[0] : obj.name.split('.')[0];
    let fileName = `${newName}.${format}`;
    downloadModal();
    let blob = await this.getBlob(url, this.props.downloadPercent);
    this.saveFile(blob, fileName);
  };
  getBlob = (fileUrl, callback) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      this.props.onUploadXHRChange(xhr);
      xhr.open('GET', fileUrl, true);
      //监听进度事件
      xhr.addEventListener(
        'progress',
        (evt) => {
          if (evt.lengthComputable) {
            let percentComplete = evt.loaded / evt.total;
            // percentage是当前下载进度，可根据自己的需求自行处理
            let percentage = percentComplete * 100;
            callback(Math.round(percentage));
          }
        },
        false
      );
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  };

  saveFile = (blob, fileName) => {
    // ie的下载
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      // 非ie的下载
      const link = document.createElement('a');
      const body = document.querySelector('body');

      link.href = window.URL.createObjectURL(blob);
      link.target = '_blank';
      link.download = fileName;

      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);

      link.click();
      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    }
  };

  handleDownload = () => {
    if (Utils.getSystemType() != 'other') {
      this.downloadFile(
        this.props.audioExtractorFileAfter,
        this.props.audioExtractorFileAfter.format,
        null,
        this.openDownLoadDialog
      );
    } else {
      Utils.downloadFile(
        this.props.audioExtractorFileAfter,
        this.props.audioExtractorFileAfter.format
      );
    }
    sendGaEvent({
      category: 'DownloadStart',
      action: '26AE_DownloadStart',
    });
  };

  render() {
    return (
      <AudioCompressCompleteRender
        advertiseConfig={this.props.advertiseConfig}
        openAdvertiseDialog={this.props.openAdvertiseDialog}
        audioExtractorFileAfter={this.props.audioExtractorFileAfter}
        handleSubmitAgain={this.props.handleSubmitAgain}
        handleDownload={this.handleDownload}
      />
    );
  }
}

export default withTranslation(['audioExtractor'])(
  AudioExtractorCompleteFunction
);
